var _g;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEnvelopeSolid = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 15 15",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "envelope-solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M13.5938 1.875C14.3701 1.875 15 2.50459 15 3.28125C15 3.72363 14.792 4.13965 14.4375 4.40625L8.0625 9.1875C7.72852 9.43652 7.27148 9.43652 6.9375 9.1875L0.5625 4.40625C0.208389 4.13965 0 3.72363 0 3.28125C0 2.50459 0.62959 1.875 1.40625 1.875H13.5938ZM6.375 9.9375C7.04297 10.4385 7.95703 10.4385 8.625 9.9375L15 5.15625V11.25C15 12.2842 14.1592 13.125 13.125 13.125H1.875C0.839356 13.125 0 12.2842 0 11.25V5.15625L6.375 9.9375Z",
    fill: "#5849A6"
  }))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEnvelopeSolid, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/envelope-solid.366f5d0d.svg";
export { ForwardRef as ReactComponent };